// add mindstore event listeners for product links in minicart to open the editor popup
// document.body.dispatchEvent(new CustomEvent('mindstore_mini_cart_refreshed', { detail: null }))
import events from './event.js';

class MindstoreHooks {

    static init() {
        // Listen for mini cart refresh events to add event listeners to product links
        document.body.addEventListener('mindstore_mini_cart_refreshed', async (e) => {
            this.addMiniCartEventListeners();
        });
    }

    static addMiniCartEventListeners() {
        document.querySelectorAll('.woocommerce-mini-cart .product-thumbnail').forEach((link) => {
            link.addEventListener('click', async (e) => {
                e.preventDefault(); // Stoppa alltid navigering omedelbart

                let mscpKey = null;
                let mscpSessionId = null;
                const originalUrl = new URL(link.getAttribute('href'), window.location.origin);

                // 1. Försök hitta nyckeln edit button
                const editButton = link.querySelector('.mscp-edit-button');
                if (editButton && editButton.dataset.cart_item_key) {
                    mscpKey = editButton.dataset.cart_item_key;
                    mscpSessionId = editButton.dataset.mscp_session_id;
                }


                // 3. Om vi fortfarande inte har en nyckel, avbryt.
                if (!mscpKey || !mscpSessionId) {
                    alert('No Mindstore Customizable Product key found for this product.');
                    return;
                }

                // 4. Bygg den RENA produkt-URL:en (utan WC-parametrar)
                // Vi tar bort 'cart_item_key' och lägger till VÅR parameter.
                originalUrl.searchParams.delete('cart_item_key');
                originalUrl.searchParams.append('mscp_edit_key', mscpKey);
                originalUrl.searchParams.append('mscp_session_id', mscpSessionId);

                const newProductLink = originalUrl.href;

                // 5. Fråga användaren och navigera
                // Notera: Vi tar bort 'else'-blocket som gav ett felmeddelande
                // if (confirm('Do you want to edit this product?')) {
                window.location.href = newProductLink;
                // }
            });
        });
    }
}

MindstoreHooks.init();

export default MindstoreHooks;